"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planningTranshipmentTypes = void 0;
exports.planningTranshipmentTypes = {
    SET_ERROR: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES REDUCER SET ERROR',
    ON_PAGE_CHANGE: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES SET SUCCESS MODAL',
    SET_DATA_GRID_TRANSHIPMENT: 'ADJUSTMENT PLANNING TRANSHIPMENT TYPES GET DATA GRID',
    SET_DATA_GRID_HISTORY: 'ADJUSTMENT PLANNING TRANSHIPMENT HISTORY TYPES GET DATA GRID',
    ON_PAGE_CHANGE_HISTORY: 'ADJUSTMENT PLANNING TRANSHIPMENT HISTORY TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE_HISTORY: 'ADJUSTMENT PLANNING TRANSHIPMENT HISTORY TYPES ON SORT CHANGE',
    ON_FILTER_CHANGE_HISTORY: 'ADJUSTMENT PLANNING TRANSHIPMENT HISTORY TYPES ON FILTER CHANGE',
    SET_LAST_SUCCEED_UPLOAD: 'ADJUSTMENT PLANNING TRANSHIPMENT HISTORY TYPES SET LAST SUCCEED UPLOAD',
};
